import EatWhatYouLove, { EatWhatYouLoveProps } from "./EatWhatYouLove";

export { EatWhatYouLove, EatWhatYouLoveProps };

export default EatWhatYouLove;
